import { createSimpleSchema, getDefaultModelSchema } from 'serializr';

export const getModelSchema = (model: any) => {
  let schema = getDefaultModelSchema(model);
  if (!schema) {
    schema = createSimpleSchema({});
  }
  return schema;
};
